module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "p-toolbar p-component mb-4"
  }, [_c('itemSubGroupDialog', {
    ref: "itemSubGroupdialog"
  })], 1), _vm._v(" "), _c('itemSubGroupList', {
    on: {
      "delete-message": _vm.deleteMessage,
      "edit-group": _vm.editItemSubGroup
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e1f9da4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/item/Itemsubgroup.vue
// module id = 2360
// module chunks = 0